import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import moment from "moment";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import JsPDF from "jspdf";
import "jspdf-autotable";
import { IMAGE_URL, TABLE_DATE_FORMAT, TABLE_DATE_TIME_FORMAT, TABLE_ROWS_PER_PAGE, TABLE_TIME_FORMAT } from "../../../utils/Constants";
import { InitialRender } from "../../common/Helper";
import {
  eBooksExportList,
  eBooksExportListCancelToken,
  GetAllDropdownValues,
} from "../../../services/RegistrationService";
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import { Link } from "react-router-dom";
import Hover from "../../common/Hover";
import Str from "../../common/Str";
import { RenderSchool } from "../../../utils/CommonGroupingItem";
import Tablefilter from "../../common/Tablefilter";
import { RenderRegistrationStatus } from "../../../utils/CommonStatusItems";
import axios from "axios";
import { handleTableScroll } from "../../../utils/commonFunction";

const createdDateArr = [{
  label: "Today",
  value: "Today"
},
{
  label: "Yesterday",
  value: "Yesterday"
},
{
  label: "Last 7 Days",
  value: "Last 7 Days"
},
{
  label: "Last 14 Days",
  value: "Last 14 Days"
},
{
  label: "Last 30 Days",
  value: "Last 30 Days"
}]

const EbooksExport = () => {
  const [loading, setloading] = useState(false);
  const [studentList, setStudentList] = useState([]);
  const [search, setSearch] = useState("");
  const [intake, setIntake] = useState({ arr: [], checkObj: {} });
  const [status, setStatus] = useState({ arr: [], checkObj: {} });
  const [school, setSchool] = useState({ arr: [], checkObj: {} });
  const [createdDate, setCreatedDate] = useState({ arr: [], checkObj: {} });
  const [intakeArr, setIntakeArr] = useState([]);
  const [commonContent, setCommonContent] = useState([]);
  const [schoolArr, setSchoolArr] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [sortkey, setSortKey] = useState('date');
  const [sortOrder, setSortOrder] = useState("DESC");

  useEffect(() => {
    handleTableScroll()
  }, [loading])
  useEffect(() => {
    const cancelTokenSources = [];

    const getData = async() => {
      setloading(true)

      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });
  
      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);

      let data = {
        page,
        limit: perPage,
        viaCreated: createdDate.arr.includes("Last 30 Days") ? "30" : createdDate.arr.includes('Last 14 Days') ? "14" : createdDate.arr.includes('Last 7 Days') ? "7" : createdDate.arr.includes('Yesterday') ? "2" : createdDate.arr.includes("Today") ? "1" : "",
        intake: intake.arr,
        viaStatus: status.arr,
        viaSearch: search,
        key: sortkey,
        sort: sortOrder,
        viaSchoolFilter: school.arr,
        exportStatus: "false",
      }

      try {
        const res = await eBooksExportListCancelToken(data, source.token);
        setTotalRows(res.data.pagination.total)
        setPage(res.data.pagination.current_page)
        setPerPage(res.data.pagination.per_page)
        setStudentList(res && res.data && res.data.res ? res.data.res : []);
        if (res.status === 200) {
          setloading(false);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setloading(false);
        }
      }
    }

    getData();
    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, [page, perPage, createdDate, intake, status, search, sortkey, sortOrder, school]);

  useEffect(() => {
    GetAllDropdownValues().then((res) => {
      let tempIntakeArr = [];
      res.data.intake_year && res.data.intake_year.length && res.data.intake_number && res.data.intake_number.length && res.data.intake_year.map(year => {
        res.data.intake_number.map(number => {
          tempIntakeArr.push({ label: `${year.label}-${number.label}`, value: `${year.value}/${number.value}` })
        })
      })
      setCommonContent(res.data.re_registration_status);
      setSchoolArr(res.data.school_type);
      setIntakeArr(tempIntakeArr);
    });
  }, [])

  const columns = useMemo(() => [
    {
      name: "Student",
      selector: "name",
      sortable: true,
      sortField: 'name',
      cell: (row) => row.first_name ? (
        <div className="assigned-title-block-new">
          <div className="assigned-title-itm">
            <span className={"assigned-title-blk  name-icon bgGreenHex  "}>
              {row.picture_me ? (<img src={`${IMAGE_URL}/${row.picture_me.replaceAll("/home/myaie/public_html/", "").replace("public/","")}`} alt="AIE" />) : (InitialRender([row.first_name, row.last_name]))}
              <span className={`profile-box-2-status ${row.activity_status ? row.activity_status.toLowerCase()=="online" ? "Online" :row.activity_status.toLowerCase()== "away"? "Away" :"Offline":"Offline"}`}>
                <i className="fas fa-circle"></i>
              </span>
              <Hover firstName={row.first_name} lastName={row.last_name} photo={row.picture_me} email={row.email} mobile={row.mobile} right={true} role="student support" status={row.student_status} activity_status={row.activity_status} showNumber={true} number={row.student_crm_id} />
            </span>
            <Link to={`/studentadministration/registration/open/registration?studentId=${row.id}&studentName=${row.first_name} ${row.last_name}`} className="as-text-blue curser feature-name" >
                <span className="textLimit100">{`${row.first_name} ${row.last_name}`}</span>
            </Link>
          </div>
        </div>
      ) : "-",
    },
    {
      name: "Date",
      selector: "date",
      sortable: true,
      sortField: 'date',
      cell: (row) => row.created_date ? (
        <div className="dateTime">
          <p className="right-space">
            {moment.unix(row.created_date).format(TABLE_DATE_FORMAT)}
          </p>
          <p>{moment.unix(row.created_date).format(TABLE_TIME_FORMAT)}</p>
        </div>
      ) : (
        "-"
      ),
    },
    {
      name: "Password",
      selector: "password",
      cell: (row) => row.password ? <span className="feature-name"><span className="textLimit100">{row.password}</span></span> : "-",
    },
    {
      name: "Email",
      selector: "email",
      sortable: true,
      sortField: 'email',
      cell: (row) => row.email ? <span className="feature-name" title={row.email}><span className="textLimit100">{row.email}</span></span> : "-"
    },
    {
      name: "Student No.",
      selector: "student_crm_id",
      sortable: true,
      sortField: 'student_crm_id',
      cell: (row) => {
        return row?.student_crm_id ? <span className="feature-name"><span className="textLimit100">{row.student_crm_id}</span></span> :"-";
      },
    },
    {
      name: "Intake",
      selector: "intake",
      sortable: true,
      sortField: 'intake',
      cell: (row) => row.intake_year && row.intake_year != 0 && row.intake_number != 0 ? `${row.intake_year} - ${row.intake_number}` : "-"
    },
    {
      name: "Status",
      selector: "status",
      sortField: 'status',
      cell: (row) => row.status ? RenderRegistrationStatus(row.status).html : "-"
    },
    {
      name: "School",
      selector: "academy",
      sortField: "academy",
      sortable: true,
      sortField: 'academy',
      cell: (row) => row.academy ? RenderSchool(row.academy).html : "-"
    },
    {
      name: "Programme",
      selector: "programme",
      sortField: 'programme',
      cell: (row) => {
        return row.class ? <Link to={`/courseAdministration/Programmes/programme/open/${row.class_id}/details`} className="as-text-blue curser feature-name"><span className="textLimit100" title={row.class}>{row.class}</span></Link> : "-";
      },
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="assessment-08">
          <div className="as-buttons">
            <Link
              to={`/studentadministration/registration/open/registration?studentId=${row.id}&stundentName=${row.first_name} ${row.last_name}`}
            >
              <button title="Open" className="btn btn-primary rounded-circle">
                <i className="fal fa-folder-open"></i>
              </button>
            </Link>
          </div>
        </div>
      ),
    },
  ]);

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
  };

  const handlePageChange = (pageNo) => {
    setPage(pageNo);
  };

  const handleSort = (column, sortDirection) => {
    setSortKey(column.sortField);
    setSortOrder(sortDirection === "asc" ? "ASC" : "DESC");
  };

  const handleFilters = (e, type = "") => {
    const value = e.target.value;
    if (type === "search") {
      setSearch(value);
    }
  };

  function resetFilter() {
    setSearch("");
    setStatus({ arr: [], checkObj: {} });
    setIntake({ arr: [], checkObj: {} })
    setCreatedDate({ arr: [], checkObj: {} });
    setSchool({ arr: [], checkObj: {} });
  }

  const exportData = (fileType, fileName) => {
    let data = {
      page,
      limit: perPage,
      viaCreated: createdDate.includes("Last 30 Days") ? "30" : createdDate.includes('Last 14 Days') ? "14" : createdDate.includes('Last 7 Days') ? "7" : createdDate.includes('Yesterday') ? "2" : createdDate.includes("Today") ? "1" : "",
      intake: intake.arr,
      viaStatus: status,
      viaSearch: search,
      key: sortkey,
      sort: sortOrder,
      exportStatus: "true",
    }
    eBooksExportList(data)
      .then((res) => {
        let data = res.data.res
        const header = [
          "Student",
          "Date",
          "Password",
          "Email",
          "Student No.",
          "Intake",
          "Status",
          "Class",
        ];
        data = data?.map((row) => ({
          ...row,
          Student: row.first_name ? row.first_name + " " + row.last_name : "-",
          Date: row.created_date
            ? moment.unix(row.created_date).format(TABLE_DATE_TIME_FORMAT)
            : "-",
          Password: row.password ? row.password : "-",
          Email: row.email ? row.email : "-",
          "Student No.": row.student_crm_id ? row.student_crm_id : "-",
          Intake: row.intake_year && row.intake_year != 0 ? row.intake_year + "-" + row.intake_number : "-",
          Status: RenderRegistrationStatus(row.status).text,
          Class: row.class ? row.class : "-",
        }));
        if (fileType === "csv") {
          const csvString = Papa.unparse({ fields: header, data });
          const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });

          const blobURL = window.URL.createObjectURL(blob);

          const anchor = document.createElement("a");
          anchor.download = fileName;
          anchor.href = blobURL;
          anchor.dataset.downloadurl = [
            "text/csv",
            anchor.download,
            anchor.href,
          ].join(":");
          anchor.click();

          setTimeout(() => {
            URL.revokeObjectURL(blobURL);
          }, 1000);
        } else if (fileType === "xlsx") {
          const compatibleData = data.map((row) => {
            const obj = {};
            header.map((col, index) => {
              obj[col] = row[col];
            });
            return obj;
          });

          let wb = XLSX.utils.book_new();
          let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
            header,
          });
          XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
          XLSX.writeFile(wb, `${fileName}.xlsx`);
          return false;
        }
        if (fileType === "pdf") {
          const compatibleData = data.map((row) => {
            return [
              row.first_name ? row.first_name + " " + row.last_name : "-",
              row.created_date
                ? moment.unix(row.created_date).format(TABLE_DATE_TIME_FORMAT)
                : "-",
              row.password ? row.password : "-",
              row.email,
              row.student_crm_id ? row.student_crm_id : "-",
              row.Intake,
              row.status,
              row.class,
            ];
          });
          const doc = new JsPDF();
          doc.autoTable({
            head: [header],
            body: compatibleData,
            styles: {
              minCellHeight: 10,
              minCellWidth: 5,
              halign: "left",
              fontSize: 8,
            },
          });
          doc.save(`${fileName}.pdf`);

          return false;
        }
      })
      .catch((error) => {
        console.error("error :", error);
      });

  };

  return (
    <div className="my-tickets-info-list Tickets-main-wrap">
      <div className="l-o-c-t custom-table-div filter-search-icon card card-table-custom">
        <div className="search-filter-div">
          <div className="search-filter-div-left">
            <div className="system-administration-table table-responsive">
              <div className="table-responsive-div">
                <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer" >
                    <div id="assessment-table-main_filter" className="dataTables_filter" >
                      <label>
                        <input type="search" className="" placeholder="Search" aria-controls="assessment-table-main" onChange={(e) => handleFilters(e, "search")} value={search} />
                      </label>
                      <div className="filter-eff filter-data-btn">
                        <button className="filter-buttons">
                          <i className="fal fa-filter"></i>
                        </button>
                      </div>
                    </div>
                </div>
              </div>
              <div className="filter-button-group">
                  <div className="filter-scroll">
                    <div className={`filter-scroll-inner  filter-custom-new`}>
                      <Tablefilter
                        filterName={"Created Date"}
                        optionArr={createdDateArr}
                        state={createdDate}
                        setState={setCreatedDate}
                        stopOptionSorting={true}
                      />
                      <Tablefilter
                        filterName={"Intake"}
                        optionArr={intakeArr}
                        state={intake}
                        setState={setIntake}
                        isOptionReversed={true}
                      />
                      <Tablefilter
                        filterName={"Status"}
                        optionArr={commonContent}
                        state={status}
                        setState={setStatus}
                        renderLabelFunction={RenderRegistrationStatus}
                      />
                      <Tablefilter
                        filterName={"School"}
                        optionArr={schoolArr}
                        state={school}
                        setState={setSchool}
                        renderLabelFunction={RenderSchool}
                      />
                    </div>
                  </div>
                  <div className="reset-btn-group">
                    <div className="button-reset dropdown-comman">
                      <button className="btn btn-primary" title="Reset" onClick={resetFilter} >
                        <i className="fal fa-redo"></i>Reset
                      </button>
                    </div>
                    <div className="files-export-group">
                      <button type="button" className="btn btn-files" onClick={() => { exportData("xlsx", "E-Books export list"); }} title="Export spreadsheet" >
                        <i className="fal fa-file-excel icon"></i>
                      </button>
                      <button type="button" className="btn btn-files" onClick={() => { exportData("csv", "E-Books export list"); }} title="Export CSV" >
                        <i className="fal fa-file-csv icon"></i>
                      </button>
                      <button type="button" className="btn btn-files" onClick={() => { exportData("pdf", "E-Books export list"); }} title="Export PDF" >
                        <i className="fal fa-file-pdf icon"></i>
                      </button>
                    </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <DataTable
          data={studentList}
          defaultSortField="date"
          defaultSortAsc={false}
          columns={columns}
          pagination={true}
          onSort={handleSort}
          noDataComponent={Str.noRecord}
          paginationServer
          sortServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          highlightOnHover={false}
          progressPending={loading}
          progressComponent={<SkeletonTicketList />}
          paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
        />
      </div>
    </div>
  );
};

export default EbooksExport;
